import { render, staticRenderFns } from "./groupA.vue?vue&type=template&id=c0318e1c&scoped=true"
import script from "./groupA.vue?vue&type=script&lang=js"
export * from "./groupA.vue?vue&type=script&lang=js"
import style0 from "./groupA.vue?vue&type=style&index=0&id=c0318e1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0318e1c",
  null
  
)

export default component.exports